export default __webpack_public_path__ + "static/media/books-17.afbd6124.jpg";